import React, { useEffect, useState } from 'react';
import { useBoardRequest } from './board-api';
import { c } from './board-ui';
import { BoardList } from './board-list';
import { BoardTeam } from './board-team';
import { BoardModeration } from './board-moderation';
import { boardPath, boardViewFromPath, type BoardView } from '../workspace-routes';

export function BoardWorkspace({
  getAccessToken,
  onAccessDenied,
}: {
  getAccessToken(): Promise<string>;
  onAccessDenied(): void;
}) {
  const [view, setView] = useState<BoardView>(() => boardViewFromPath(window.location.pathname));
  const request = useBoardRequest(getAccessToken, onAccessDenied);
  useEffect(() => {
    const restoreRoute = () => setView(boardViewFromPath(window.location.pathname));
    window.addEventListener('popstate', restoreRoute);
    return () => window.removeEventListener('popstate', restoreRoute);
  }, []);
  return (
    <div className="min-w-0">
      <header className="admin-page-header">
        <h1>{c.title}</h1>
        <p className="mt-3 max-w-2xl text-sm leading-6 text-ink-soft">{c.intro}</p>
      </header>
      <nav className="admin-tabs mb-8" aria-label={c.title}>
        {(['picks', 'quizzes', 'team', 'moderation'] as const).map((value) => (
          <a
            key={value}
            aria-current={view === value ? 'page' : undefined}
            href={boardPath(value)}
            onClick={(event) => {
              if (
                event.button === 0 &&
                !event.metaKey &&
                !event.ctrlKey &&
                !event.shiftKey &&
                !event.altKey
              ) {
                event.preventDefault();
                const path = boardPath(value);
                if (window.location.pathname !== path) {
                  window.history.pushState({}, '', path);
                  window.dispatchEvent(new PopStateEvent('popstate'));
                }
                setView(value);
              }
            }}
          >
            {c[value]}
          </a>
        ))}
      </nav>
      {view === 'team' ? (
        <BoardTeam request={request} />
      ) : view === 'moderation' ? (
        <BoardModeration request={request} />
      ) : (
        <BoardList key={view} kind={view === 'picks' ? 'picks' : 'quiz'} request={request} />
      )}
    </div>
  );
}
